import React from "react";

function BlackBar() {
  return (
    <>

    {/* BLACK BAR */}
    
      <div className="w-full bg-black hidden md:block">
        <div className="w-full md:w-10/12 lg:w-7/12 mx-auto">
          <div className="flex flex-row justify-between py-0.5">
            {/* Left */}
            <div className="flex flex-row items-center">
              <div className="mr-1 text-xs-s text-white cursor-pointer font-semibold">
              <i class="fas fa-moon"></i>
              </div>
              <div className="mr-5 text-xs-s text-white cursor-pointer tracking-widest font-semibold">
                8.7<sup>c</sup>  New York
              </div>
              <div className="mr-5 text-xs-s text-white cursor-pointer tracking-widest">
                Friday, April 23, 2021
              </div>
              <div className="mr-5 text-xs-s text-white cursor-pointer tracking-widest">
                Sign in / Join
              </div>
              <div className="mr-5 text-xs-s text-white cursor-pointer tracking-widest">Blog</div>
              <div className="mr-5 text-xs-s text-white cursor-pointer tracking-widest">
                Forum
              </div>
              <div className="mr-5 text-xs-s text-white cursor-pointer tracking-widest">
                Buy now!
              </div>
            </div>

            {/* Right */}
            <div className="flex flex-row items-center">
              <div>
                <i class="fab fa-facebook-f text-white cursor-pointer  hover:text-blue-500 text-xs mr-5"></i>
              </div>
              <div>
                <i class="fab fa-instagram text-white cursor-pointer  hover:text-yellow-500 text-xs mr-5"></i>
              </div>
              <div>
                <i class="fab fa-twitter text-white cursor-pointer  hover:text-blue-500 text-xs mr-5"></i>
              </div>
              <div>
                <i class="fab fa-vimeo-v text-white cursor-pointer  hover:text-green-500 text-xs mr-5"></i>
              </div>
              <div>
                <i class="fab fa-youtube text-white cursor-pointer  hover:text-red-500 text-xs"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default BlackBar;
